<template>
  <div>
    <a-form class="ant-advanced-search-form">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="学员姓名">
            <a-input placeholder="学员姓名/手机号" v-model="where.keyword.name" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="所属企业">
            <a-input placeholder="所属企业" v-model="where.keyword.company" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="用户组">
            <a-select show-search v-model="where.keyword.groupIds" :filter-option="filterOption" allowClear @change="groupChanged">
              <a-select-option
                :value="info.id"
                v-for="(info, index) in grouplist"
                :key="index"
              >{{info.name}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="所在地区">
            <a-cascader
              :options="areas"
              placeholder="请选择所在地区"
              @change="areaChange"
              :default-value="areaList"
              :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="选择证书">
            <a-select  allowClear @change="certificateChanged">
              <a-select-option
                      :value="info.id"
                      v-for="(info, index) in certificateList"
                      :key="index"
              >{{info.name}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <pxkeji-btn name="课程筛选" class="pxkeji_basic_btn" @click="selectCourse()" type="primary" />
        </a-col>
        <a-col :span="3" :style="{ textAlign: 'left' }">
          <a-button type="primary" @click="searchList">搜索</a-button>
        </a-col>
      </a-row>
    </a-form>

    <a-table
      :columns="list.columns"
      rowKey="id"
      :pagination="list.pagination"
      @change="onChange"
      :dataSource="list.datas"
      :loading="isloading"
      :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows,getCheckboxProps:getCheckboxProps}"
      :locale="{emptyText:'暂无数据'}"
    >
      <span slot="action" slot-scope="action">
        <span v-if="action.area">{{action.province}}/{{action.city}}/{{action.area}}</span>
      </span>
    </a-table>
    <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
      <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
      <pxkeji-btn name="确定" type="primary" class="nextBtn" @click="showSignup" />
    </a-form-item>
    <a-modal
            v-model="chooseCourseShow"
            :footer="false"
            destroyOnClose
            width="70%"
            :maskClosable="false"
            class="ui-modal"
    >
      <courseChoose @callbackMethod="addCourse" />
    </a-modal>

  </div>

</template>
<script>
  import courseChoose from "./courseChoose.vue";
var that;
const columns = [
  {
    dataIndex: "fullName",
    key: "fullName",
    align: "center",
    title: "学员名称",
  },
  {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号",
  },
  {
    dataIndex: "idCard",
    key: "idCard",
    align: "center",
    title: "身份证号",
  },
  {
    dataIndex: "sex",
    key: "sex",
    align: "center",
    title: "性别",
  },
  {
    key: "action",
    align: "center",
    title: "地区",
    scopedSlots: { customRender: "action" },
  },
  {
    dataIndex: "enterprise.name",
    key: "enterpriseName",
    align: "center",
    title: "所属单位",
  },
  {
    dataIndex: "extensions.groupName",
    key: "groupName",
    align: "center",
    title: "管理组名称",
  },
];

export default {
  props: {
    id: Array,
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10, //页容
        },
      },
      chooseCourseShow:false,
      addedit: {
        num: 0,
        visible: false,
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          company: "",
          groupIds: "",
          province: "",
          city: "",
          area: "",
          studentIds:"",
        },
      },
      selectRows: [], //选中项编号
      allSelectRows: {},
      isloading: false,
      grouplist: [],
      certificateList:[],
      areas: [],
      areaList: [],
      courseIds:"",
      type:"",
    };
  },
  components: {
    // Info: Info,
    courseChoose,
  },
  mounted: function () {
    this.$nextTick(function () {
      that = this;
      this.getArea();
      this.getgrouplist();
      this.GetList();
      this.getCertificateList();
    });
  },
  watch: {
    selectRows: function () {},
  },
  methods: {
    getArea() {
      this.areas = this.$api.city.city;
    },
    areaChange(value) {
      this.where.keyword.province = value[0];
      this.where.keyword.city = value[1];
      this.where.keyword.area = value[2];
    },
    groupChanged(v) {
      this.where.keyword.groupIds = v;
    },
    certificateChanged(v){
      this.$api.student
              .getStudentIdsByCertifiCateId(v)
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.where.keyword.studentIds = res.data.join(",");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
                this.error();
              });
    },
    getgrouplist() {
      this.isloading = true;
      this.$api.usergroup
        .getAll()
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.grouplist = res.data;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    // 2021 10 22 start
    filterOption(input, option) {
     return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 2021 10 22 end
    getCertificateList() {
      this.isloading = true;
      this.$api.certificate
              .getAll()
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.certificateList = res.data;
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
                this.error();
              });
    },
    getCheckboxProps(record) {

      var checked = false;
      var currentlist = this.allSelectRows;
      currentlist=this.id;

      for (var i in currentlist) {
        if (currentlist[i] == record.id) {
          checked = true;
          break;
        }
      }
      return {
        defaultChecked: checked,
      };
    },
    selectCourse(){
      this.chooseCourseShow = true;
    },
    addCourse(courseIds,type){
      this.chooseCourseShow = false;
      this.courseIds=courseIds;
      this.type=type;
      // this.GetList()
     this.getStudnetIdsList()
    },
    cancelClick() {
      this.$emit("callbackMethod");
    },
    GetList() {
      //获取列表
      this.isloading = true;
      var params = {
        pageNow: this.list.pagination.current,
        pageSize: this.list.pagination.defaultPageSize,
        name: this.where.keyword.name,
        enterpriseName: this.where.keyword.company,
        studentIds: this.where.keyword.studentIds,
      };
      if (this.where.keyword.groupIds) {
        params.groupId = this.where.keyword.groupIds;
      }
      if (this.where.keyword.area) {
        params.province = this.where.keyword.province;
        params.city = this.where.keyword.city;
        params.area = this.where.keyword.area;
      }
      this.$api.student
        .getPagedList(params)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            for (let i = 0; i < this.list.datas.length; i++) {
              var ex = this.list.datas[i].extensions;
              this.list.datas[i].extensions = JSON.parse(ex);
            }
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    getStudnetIdsList() {
      //获取列表
      this.isloading = true;
      this.$api.order
              .getUsersByTypeAndCourse(this.courseIds,this.type)
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.where.keyword.studentIds=res.data.join(",");
                  this.GetList()
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调

      this.list.pagination.current = page.current;

      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      this.selectRows = selectedRowKeys;
      this.allSelectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      //清空选择
      for (var key in this.allSelectRows) {
        delete this.allSelectRows[key];
      }
      this.selectRows = [];
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showSignup() {
      var allids = [];
      for (var row in this.allSelectRows) {
            if (allids.indexOf(this.allSelectRows[row]) == -1) {
              allids.push(this.allSelectRows[row]);
            }
      }
      if (allids.length == 0) {
        this.$emit("callbackMethod", this.where.keyword.name,this.where.keyword.company,this.where.keyword.studentIds,
                this.where.keyword.provience,this.where.keyword.city,this.where.keyword.area,this.where.keyword.groupIds);
        return;
      }
      var selList = allids.join(",");
      //打开弹出框
      this.$emit("callbackMethod", null,null,selList,
              null,null,null,null);

    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {},
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.user
        .prohibit(ids, status)
        .then((res) => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },

    save() {
      this.addedit.visible = false;
      this.GetList();
    },
  },
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
.nextBtn {
  margin-left: 20px;
}
</style>

